<template>
    <FinanceData/>
</template>

<script>
import { FinanceData } from 'shared'

export default {
    name: 'financeData',
    components: {
        FinanceData
    },
    data() {
        return {
            params: {
                name: '零售电商',
                a103: '直播电商'
            }
        }
    },
    created() {
        this.$store.dispatch('getFinancing', this.params)
    },
}
</script>